import { Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { ColumnComponentProps } from '../../../types/activity-column-types';
import { getItemCode } from '../../../utils/activity-formatters';

export function ItemCodeColumn({
  info,
}: ColumnComponentProps<
  BackofficeActivitiesOrderItem,
  string | number | undefined
>) {
  const itemCode = getItemCode(info.row.original);

  return (
    <Text fontSize="sm" fontWeight="400" color="#373F41">
      {itemCode}
    </Text>
  );
}
